import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

type ConfirmNotificationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmNotificationDialog = (
  props: ConfirmNotificationDialogProps,
): JSX.Element => {
  const { open, onClose, onConfirm } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      slotProps={{
        paper: { sx: { m: 3 } },
      }}
      maxWidth="xs"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ p: 2, fontWeight: 'fontWeightBold' }}
        variant="body1"
      >
        {t('addIncidentReport.confirmNotificationType.message')}
      </DialogTitle>
      <DialogActions sx={{ p: 2, flexDirection: 'column', gap: 2 }}>
        <Button
          onClick={onConfirm}
          color="primary"
          size="large"
          fullWidth
          autoFocus
        >
          {t('addIncidentReport.confirmNotificationType.confirm')}
        </Button>
        <Button onClick={onClose} color="neutral" size="large" fullWidth>
          {t('common.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
